import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { AgentRating } from '../classes/agentRating';
import { CacheService } from './cache.service';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RankMyAgentService {

  // Remax does not pay for use of this api key, so we've left it in the front end
  private readonly apiKey = 'jrbVr7YT9OiADr4ZGLbSh75kF4Jo5NnD8dnKMJxe5twfK80Gva05sDOQFGegOeB0';
  private readonly apiRoot = 'https://rankmyagent.com/API';

  constructor(
    private httpClient: HttpClient,
    private cache: CacheService,
  ) { }

  getAgentRating(personifyId: string): Observable<AgentRating> {
    const route = `${this.apiRoot}/GetAgent`;
    const params = new HttpParams()
      .set('personify_id', personifyId)
      .set('key', this.apiKey);

    const hashKey = this.cache.getRequestHash(route, params);
    const hashValue = this.cache.get<AgentRating>(hashKey);
    if (hashValue) {
      return of(!!hashValue.personify_id ? hashValue : null); // Check if cached value has any data, otherwise return null instead of {}
    }

    return this.httpClient.get<AgentRating>(route, { params: params, withCredentials: false }).pipe(
      catchError((err: HttpErrorResponse) => of(null)),   // Run catchError before caching so we can cache a 404
      tap(rating => this.cache.set(hashKey, rating, 1000))
    );
  }
}
